import { allFetch } from "../Domain";

/**
 * @description 車庫存
 */
export const CarStock = (() => {
    /**
     * @description 新增新車庫存
     */
    const NewCarStockCreate = async function (obj = {
        store_department: '',
        store_space: '',
        transaction_code: '',
        SIDO_no: '',
        upd_time: '',
        predict_arrive_port_date: '',
        car_type: '',
        year: '',
        vin_no: '',
        interior_color: '',
        interior_code: '',
        special_equipment: '',
        note: '',
    }) {
        return await allFetch('CarStock/NewCarStockCreate', obj);
    }

    /**
     * @description 車庫存查詢
     */
    const CarStockSearch = async function (obj = {
        license_plate: '',
        SIDO_no: '',
        vin_no: '',
        SMT_status: '',
        position_id: '',
        store_department: '',
        cw_id: '',
        ct_id: '',
        year: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockSearch', obj);
    }

    /**
     * @description 修改車庫存
     */
    const CarStockUpdate = async function (obj = {
        cs_id: '',
        store_department: '',
        store_space: '',
        transaction_code: '',
        SIDO_no: '',
        upd_time: '',
        predict_arrive_port_date: '',
        car_type_code: '',
        year: '',
        vin_no: '',
        interior_color: '',
        interior_code: '',
        special_equipment: '',
        note: '',
    }) {
        return await allFetch('CarStock/CarStockUpdate', obj);
    }

    /**
     * @description 車庫存匯入查詢
     */
    const CarStockImportSearch = async function (obj = {
        cre_time: '',
        SIDO_no: '',
        vin_no: '',
        car_type: '',
        format_code: '',
        year: '',
        exterior_code: '',
        interior_code: '',
        note: '',
        arrive_port_date_start: '',
        arrive_port_date_end: '',
        special_equipment: '',
        reserve_status: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockImportSearch', obj);
    }

    /**
     * @description 車庫存細項
     * @param {string} cs_id 車庫存流水號
     */
    const CarStockDetail = async function (obj = {
        cs_id: '',
    }) {
        return await allFetch('CarStock/CarStockDetail', obj);
    }

    /**
     * @description 車庫存修改是否可見
     * @param {string} cs_id 車庫存流水號
     * @param {string} visible 是否可見
     */
    const CarStockUpdateVisible = async function (obj = {
        cs_id: '',
        visible: '',
    }) {
        return await allFetch('CarStock/CarStockUpdateVisible', obj);
    }

    /**
     * @description 車庫存修改是否可銷售
     * @param {string} cs_ids 車庫存流水號們
     * @param {string} saleable 是否可銷售
     */
    const CarStockUpdateSaleable = async function (obj = {
        cs_ids: '',
        saleable: '',
    }) {
        return await allFetch('CarStock/CarStockUpdateSaleable', obj);
    }

    /**
     * @description 車庫存查詢狀態列表
     */
    const CarStockStatusList = async function (obj = {}) {
        return await allFetch('CarStock/CarStockStatusList', obj);
    }

    /**
     * @description 查所有車庫存
     */
    const CarStockSearchAll = async function (obj = {
        license_plate: '',
        SIDO_no: '',
        vin_no: '',
        ct_id: '',
        SMT_status: '',
        position_id: '',
        store_department: '',
        cw_id: '',
        format_code: '',
        year: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockSearchAll', obj);
    }

    /**
     * @description 移庫記錄新增
     * @param {string} cs_id 車庫存流水號
     * @param {string} cw_id 車倉儲流水號
     * @param {string} predict_arrive_date 預計抵達日期
     * @param {string} note 備註
     */
    const CarStockTransportCreate = async function (obj = {
        cs_id: '',
        cw_id: '',
        predict_arrive_date: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockTransportCreate', obj);
    }

    /**
     * @description 移庫記錄查詢
     * @param {string} id 移庫紀錄流水號
     * @param {string} cs_id 車庫存流水號
     * @param {string} predict_arrive_date_start 預計抵達日期起
     * @param {string} predict_arrive_date_end 預計抵達日期迄
     * @param {string} actual_arrive_date_start 實際抵達日期起
     * @param {string} actual_arrive_date_end 實際抵達日期迄
     * @param {string} ischeck 是否確認
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockTransportSearch = async function (obj = {
        id: '',
        cs_id: '',
        predict_arrive_date_start: '',
        predict_arrive_date_end: '',
        actual_arrive_date_start: '',
        actual_arrive_date_end: '',
        ischeck: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockTransportSearch', obj);
    }

    /**
     * @description 移位記錄新增
     * @param {string} id 移庫紀錄流水號
     * @param {string} cs_id 車庫存流水號
     * @param {string} cw_id 車倉儲流水號
     * @param {string} predict_arrive_date 預計抵達日期
     * @param {string} note 備註
     */
    const CarStockTransportUpdate = async function (obj = {
        id: '',
        cs_id: '',
        cw_id: '',
        predict_arrive_date: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockTransportUpdate', obj);
    }

    /**
     * @description 移位記錄新增
     * @param {string} id 移庫紀錄流水號
     * @param {string} actual_arrive_date 實際抵達日期
     */
    const CarStockTransportCheck = async function (obj = {
        id: '',
        actual_arrive_date: ''
    }) {
        return await allFetch('CarStock/CarStockTransportCheck', obj);
    }

    /**
     * @description 移庫歷史記錄查詢
     * @param {string} cs_id 車庫存流水號
     * @param {string} vin_no VIN號碼
     * @param {string} cw_id 車倉儲流水號
     * @param {string} custody_unit_id 保管單位編號
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockTransportLogSearch = async function (obj = {
        cs_id: '',
        vin_no: '',
        cw_id: '',
        custody_unit_id: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockTransportLogSearch', obj);
    }

    /**
     * @description 移位記錄新增
     * @param {string} cs_id 車庫存流水號
     * @param {string} cw_id 車倉儲流水號
     * @param {string} note 備註
     */
    const CarStockShiftCreate = async function (obj = {
        cs_id: '',
        cw_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockShiftCreate', obj);
    }

    /**
     * @description 移位記錄查詢
     * @param {string} cs_id 車庫存流水號
     * @param {string} date_start 日期起
     * @param {string} date_end 日期迄
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockShiftSearch = async function (obj = {
        cs_id: '',
        date_start: '',
        date_end: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockShiftSearch', obj);
    }

    /**
     * @description 借車鑰匙
     * @param {string} cs_id 車庫存流水號
     * @param {string} borrow_time 借出時間
     * @param {string} borrow_user_id 借出使用者流水號
     * @param {string} note 備註
     */
    const CarStockKeyManageBorrow = async function (obj = {
        cs_id: '',
        borrow_time: '',
        borrow_user_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockKeyManageBorrow', obj);
    }

    /**
     * @description 還車鑰匙
     * @param {string} cskm_id 車鑰匙管理流水號
     * @param {string} return_time 歸還時間
     * @param {string} return_user_id 歸還使用者流水號
     * @param {string} note 備註
     */
    const CarStockKeyManageReturn = async function (obj = {
        cskm_id: '',
        return_time: '',
        return_user_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockKeyManageReturn', obj);
    }

    /**
     * @description 車鑰匙紀錄查詢
     * @param {string} cs_id 車庫存流水號
     * @param {string} borrow_time_start 借出時間起
     * @param {string} borrow_time_end 借出時間迄
     * @param {string} borrow_user_id 借出使用者流水號
     * @param {string} return_time_start 歸還時間起
     * @param {string} return_time_end 歸還時間迄
     * @param {string} return_user_id 歸還使用者流水號
     * @param {string} isreturn 是否歸還
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockKeyManageSearch = async function (obj = {
        cs_id: '',
        borrow_time_start: '',
        borrow_time_end: '',
        borrow_user_id: '',
        return_time_start: '',
        return_time_end: '',
        return_user_id: '',
        isreturn: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockKeyManageSearch', obj);
    }

    /**
     * @description 新建車鑰匙
     * @param {string} cs_id 車庫存流水號
     * @param {string} note 備註
     */
    const CarStockKeyCreate = async function (obj = {
        cs_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockKeyCreate', obj);
    }

    /**
     * @description 查詢車鑰匙
     * @param {string} cs_id 車庫存流水號
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockKeySearch = async function (obj = {
        cs_id: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockKeySearch', obj);
    }

    /**
     * @description 修改車鑰匙
     * @param {string} csk_id 車鑰匙流水號
     * @param {string} note 備註
     */
    const CarStockKeyUpdate = async function (obj = {
        csk_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockKeyUpdate', obj);
    }

    /**
     * @description 刪除車鑰匙
     * @param {string} csk_id 車鑰匙流水號
     */
    const CarStockKeyDelete = async function (obj = {
        csk_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockKeyDelete', obj);
    }

    /**
     * @description 車鑰匙細項
     * @param {string} csk_id 車鑰匙流水號
     */
    const CarStockKeyDetail = async function (obj = {
        csk_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockKeyDetail', obj);
    }

    /**
     * @description 新建車QRCode
     * @param {string} cs_id 車庫存流水號
     * @param {string} qrcode_type QRCode種類
     * @param {string} note 備註
     */
    const CarStockQRCodeCreate = async function (obj = {
        cs_id: '',
        qrcode_type: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockQRCodeCreate', obj);
    }

    /**
     * @description 查詢車QRCode
     * @param {string} cs_id 車庫存流水號
     * @param {string} qrcode_type QRCode種類
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockQRCodeSearch = async function (obj = {
        cs_id: '',
        qrcode_type: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockQRCodeSearch', obj);
    }

    /**
     * @description 修改車QRCode
     * @param {string} csqrc_id 車庫存QRCode流水號
     * @param {string} qrcode_type QRCode種類
     * @param {string} note 備註
     */
    const CarStockQRCodeUpdate = async function (obj = {
        csqrc_id: '',
        qrcode_type: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockQRCodeUpdate', obj);
    }

    /**
     * @description 刪除車QRCode
     * @param {string} csqrc_id 車庫存QRCode流水號
     */
    const CarStockQRCodeDelete = async function (obj = {
        csqrc_id: ''
    }) {
        return await allFetch('CarStock/CarStockQRCodeDelete', obj);
    }

    /**
     * @description 新建車QRCode
     * @param {string} csqrc_id 車庫存QRCode流水號
     */
    const CarStockQRCodeDetail = async function (obj = {
        csqrc_id: ''
    }) {
        return await allFetch('CarStock/CarStockQRCodeDetail', obj);
    }

    /**
     * @description 新建車管理紀錄
     * @param {string} cs_id 車庫存流水號
     * @param {string} type 類型
     * @param {string} id id
     * @param {string} time 時間
     * @param {string} user_id 使用者流水號
     * @param {string} note 備註
     */
    const CarStockManageLogCreate = async function (obj = {
        cs_id: '',
        type: '',
        id: '',
        time: '',
        user_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockManageLogCreate', obj);
    }

    /**
     * @description 查詢車管理紀錄
     * @param {string} cs_id 車庫存流水號
     * @param {string} master_type 主項類型
     * @param {string} detail_type 細項類型
     * @param {string} id id
     * @param {string} time_start 時間起
     * @param {string} time_end 時間迄
     * @param {string} user_id 使用者流水號
     * @param {string} note 備註
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockManageLogSearch = async function (obj = {
        cs_id: '',
        master_type: '',
        detail_type: '',
        id: '',
        time_start: '',
        time_end: '',
        user_id: '',
        note: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockManageLogSearch', obj);
    }

    /**
     * @description 修改車管理紀錄
     * @param {string} csml_id 車庫存管理紀錄流水號
     * @param {string} id id
     * @param {string} time 時間
     * @param {string} user_id 使用者流水號
     */
    const CarStockManageLogUpdate = async function (obj = {
        csml_id: '',
        id: '',
        time: '',
        user_id: '',
        note: ''
    }) {
        return await allFetch('CarStock/CarStockManageLogUpdate', obj);
    }

    /**
     * @description 刪除車管理紀錄
     * @param {string} csml_id 車庫存管理紀錄流水號
     */
    const CarStockManageLogDelete = async function (obj = {
        csml_id: '',
    }) {
        return await allFetch('CarStock/CarStockManageLogDelete', obj);
    }

    /**
     * @description 車管理紀錄細項
     * @param {string} csml_id 車庫存管理紀錄流水號
     */
    const CarStockManageLogDetail = async function (obj = {
        csml_id: '',
    }) {
        return await allFetch('CarStock/CarStockManageLogDetail', obj);
    }

    /**
     * @description 車庫存保留查詢
     * @param {string} ct_id 車型流水號
     * @param {string} ctf_id 車型規格流水號
     * @param {string} ce_id 外裝流水號
     * @param {string} ci_id 內裝流水號
     * @param {string} year 年式
     * @param {string} status 狀態
     * @param {string} arrive_port_date_start 到港日期起
     * @param {string} arrive_port_date_end 到港日期迄
     */
    const CarStockReserveSearch = async function (obj = {
        ct_id: '',
        ctf_id: '',
        ce_id: '',
        ci_id: '',
        year: '',
        status: '',
        arrive_port_date_start: '',
        arrive_port_date_end: ''
    }) {
        return await allFetch('CarStock/CarStockReserveSearch', obj);
    }

    /**
     * @description 車庫存保留細項
     * @param {string} ct_id 車型流水號
     * @param {string} ctf_id 車型規格流水號
     * @param {string} ce_id 外裝流水號
     * @param {string} ci_id 內裝流水號
     * @param {string} year 年式
     * @param {string} status 狀態
     * @param {string} arrive_port_date_start 到港日期起
     * @param {string} arrive_port_date_end 到港日期迄
     */
    const CarStockReserveDetail = async function (obj = {
        ct_id: '',
        ctf_id: '',
        ce_id: '',
        ci_id: '',
        year: '',
        status: '',
        arrive_port_date_start: '',
        arrive_port_date_end: ''
    }) {
        return await allFetch('CarStock/CarStockReserveDetail', obj);
    }

    /**
     * @description 新建車庫存保留紀錄
     * @param {string} ct_id 車型流水號
     * @param {string} ctf_id 車型規格流水號
     * @param {string} ce_id 外裝流水號
     * @param {string} ci_id 內裝流水號
     * @param {string} year 年式
     * @param {string} status 狀態
     * @param {string} arrive_port_date_start 到港日期起
     * @param {string} arrive_port_date_end 到港日期迄
     * @param {string} reserve_note 保留備註
     */
    const CarStockReserveLogCreate = async function (obj = {
        ct_id: '',
        ctf_id: '',
        ce_id: '',
        ci_id: '',
        year: '',
        status: '',
        arrive_port_date_start: '',
        arrive_port_date_end: ''
    }) {
        return await allFetch('CarStock/CarStockReserveLogCreate', obj);
    }

    /**
     * @description 車庫存保留紀錄確認
     * @param {string} csrl_id 車庫存保留紀錄流水號
     * @param {string} isagree 是否同意
     * @param {string} cs_id 車庫存流水號
     * @param {string} reserve_reason 保留原因
     */
    const CarStockReserveLogCheck = async function (obj = {
        csrl_id: '',
        isagree: '',
        cs_id: '',
        reserve_reason: ''
    }) {
        return await allFetch('CarStock/CarStockReserveLogCheck', obj);
    }

    /**
     * @description 車庫存保留紀錄查詢
     * @param {string} csrl_id 車庫存保留紀錄流水號
     */
    const CarStockReserveLogCancel = async function (obj = {
        csrl_id: '',
    }) {
        return await allFetch('CarStock/CarStockReserveLogCancel', obj);
    }

    /**
     * @description 車庫存保留紀錄查詢
     * @param {string} user_id 使用者流水號
     * @param {string} ischeck 是否確認
     * @param {string} isagree 是否同意
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockReserveLogSearch = async function (obj = {
        user_id: '',
        ischeck: '',
        isagree: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockReserveLogSearch', obj);
    }

    /**
     * @description 車庫存保留紀錄細項
     * @param {string} csrl_id 車庫存保留紀錄流水號
     */
    const CarStockReserveLogDetail = async function (obj = {
        csrl_id: '',
    }) {
        return await allFetch('CarStock/CarStockReserveLogDetail', obj);
    }

    /**
     * @description 車庫存保留匯入主項查詢
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockReserveImportMasterSearch = async function (obj = {
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockReserveImportMasterSearch', obj);
    }

    /**
     * @description 車庫存保留匯入主項細項
     * @param {string} csrim_id 車庫存保留匯入主項流水號
     */
    const CarStockReserveImportMasterDetail = async function (obj = {
        csrim_id: '',
    }) {
        return await allFetch('CarStock/CarStockReserveImportMasterDetail', obj);
    }

    /**
     * @description 車庫存保留匯入細項查詢(只查最新匯入的細項)
     * @param {string} csrim_id 車庫存保留匯入主項流水號
     * @param {string} ct_id 車型流水號
     * @param {string} ctf_id 車型規格流水號
     * @param {string} ce_id 外裝流水號
     * @param {string} ci_id 內裝流水號
     * @param {string} year 年式
     * @param {string} note 備註
     * @param {string} arrive_port_date_start 到港日期起
     * @param {string} arrive_port_date_end 到港日期迄
     * @param {string} special_equipment 特殊配備
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockReserveImportDetailSearch = async function (obj = {
        csrim_id: '',
        ct_id: '',
        ctf_id: '',
        ce_id: '',
        ci_id: '',
        year: '',
        note: '',
        arrive_port_date_start: '',
        arrive_port_date_end: '',
        special_equipment: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockReserveImportDetailSearch', obj);
    }

    /**
     * @description 車庫存保留匯入細項細項
     * @param {string} csrid_id 車庫存保留匯入細項流水號
     */
    const CarStockReserveImportDetailDetail = async function (obj = {
        csrid_id: '',
    }) {
        return await allFetch('CarStock/CarStockReserveImportDetailDetail', obj);
    }

    /**
     * @description 新建車庫存匯入保留紀錄
     * @param {string} csrid_id 車庫存保留匯入細項流水號
     * @param {string} reserve_note 保留備註
     */
    const CarStockReserveImportLogCreate = async function (obj = {
        csrid_id: '',
        reserve_note: ''
    }) {
        return await allFetch('CarStock/CarStockReserveImportLogCreate', obj);
    }

    /**
     * @description 車庫存匯入保留紀錄查詢
     * @param {string} user_id 使用者流水號
     * @param {string} ischeck 是否確認
     * @param {string} isagree 是否同意
     * @param {string} excel 是否匯出
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarStockReserveImportLogSearch = async function (obj = {
        user_id: '',
        ischeck: '',
        isagree: '',
        excel: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarStock/CarStockReserveImportLogSearch', obj);
    }

    /**
     * @description 車庫存匯入保留紀錄確認
     * @param {string} csril_id 車庫存匯入保留紀錄
     * @param {string} isagree 是否同意
     * @param {string} reserve_reason 保留原因
     */
    const CarStockReserveImportLogCheck = async function (obj = {
        csril_id: '',
        isagree: '',
        reserve_reason: ''
    }) {
        return await allFetch('CarStock/CarStockReserveImportLogCheck', obj);
    }

    /**
     * @description 車庫存匯入保留紀錄確認
     * @param {string} csril_id 車庫存匯入保留紀錄
     */
    const CarStockReserveImportLogCancel = async function (obj = {
        csril_id: '',
    }) {
        return await allFetch('CarStock/CarStockReserveImportLogCancel', obj);
    }

    /**
     * @description 車庫存匯入保留紀錄細項
     * @param {string} csril_id 車庫存匯入保留紀錄
     */
    const CarStockReserveImportLogDetail = async function (obj = {
        csril_id: '',
    }) {
        return await allFetch('CarStock/CarStockReserveImportLogDetail', obj);
    }

    return {
        NewCarStockCreate,
        CarStockSearch,
        CarStockUpdate,
        CarStockImportSearch,
        CarStockDetail,
        CarStockUpdateVisible,
        CarStockUpdateSaleable,
        CarStockStatusList,
        CarStockSearchAll,
        CarStockTransportCreate,
        CarStockTransportSearch,
        CarStockTransportUpdate,
        CarStockTransportCheck,
        CarStockTransportLogSearch,
        CarStockShiftCreate,
        CarStockShiftSearch,
        CarStockKeyManageBorrow,
        CarStockKeyManageReturn,
        CarStockKeyManageSearch,
        CarStockKeyCreate,
        CarStockKeySearch,
        CarStockKeyUpdate,
        CarStockKeyDelete,
        CarStockKeyDetail,
        CarStockQRCodeCreate,
        CarStockQRCodeSearch,
        CarStockQRCodeUpdate,
        CarStockQRCodeDelete,
        CarStockQRCodeDetail,
        CarStockManageLogCreate,
        CarStockManageLogSearch,
        CarStockManageLogUpdate,
        CarStockManageLogDelete,
        CarStockManageLogDetail,
        CarStockReserveSearch,
        CarStockReserveDetail,
        CarStockReserveLogCreate,
        CarStockReserveLogCheck,
        CarStockReserveLogCancel,
        CarStockReserveLogSearch,
        CarStockReserveLogDetail,
        CarStockReserveImportMasterSearch,
        CarStockReserveImportMasterDetail,
        CarStockReserveImportDetailSearch,
        CarStockReserveImportDetailDetail,
        CarStockReserveImportLogCreate,
        CarStockReserveImportLogSearch,
        CarStockReserveImportLogCheck,
        CarStockReserveImportLogCancel,
        CarStockReserveImportLogDetail
    }
})();